import DataFetcherTemplate from "../hooks/fetchTemplate";
import Notification from "../components/BlockRightImage";
import BlockImageCabecera from "../components/BlockImageCabecera";
import { NavLink } from "react-router-dom";
import Breadcumbs from "../components/Breadcumbs";
import Block3Columns from "../components/Block3Columns";
import Block4ColumnsText from "../components/Block4ColumnsText";
import Block2ColumnsText from "../components/Block2ColumnsText";
import Accordion from "../components/Accordion";
import BlockBackgroundImage from "../components/BlockBackgroundImage";
import BlockRightImage from "../components/BlockRightImage";
import BlockLeftImage from "../components/BlockLeftImage";

function ConsultoriosPsicologia() {
  const DataDisplay = ({ data }) => (
    <>
      <>
        {data.map((item, index) => (
          <>
            <BlockImageCabecera
              src={item.field_portada}
              title={
                <>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_texto_portada,
                    }}
                  />
                </>
              }
            ></BlockImageCabecera>
            <Breadcumbs
              content={
                <>
                  <NavLink to="/consultorios-psicologia">
                    Consultorios Psicología
                  </NavLink>
                </>
              }
            ></Breadcumbs>
            <div>
              <div className="layout8">
                <center>
                  <div
                    className="width500"
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque1,
                    }}
                  />
                  <br></br>
                  <br></br>
                </center>
              </div>
              <Block2ColumnsText
                col1={
                  <>
                    <img src={item.field_imagen2}></img>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque2,
                      }}
                    />
                  </>
                }
                col2={
                  <>
                    <img src={item.field_imagen3}></img>

                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque3,
                      }}
                    />
                  </>
                }
              ></Block2ColumnsText>
            </div>{" "}
            <div className="padding bluebg margin  ">
              <center>
                <p className="iconsize20">⏰📍</p>
              </center>

              <div
                className="  fontsize14 width700"
                dangerouslySetInnerHTML={{
                  __html: item.field_bloque4,
                }}
              />
            </div>
            <div className="padding lightbluebg   ">
              <center>
                {" "}
                <p className="iconsize20">📱</p>
                <div
                  className=" fontsize14 width700"
                  dangerouslySetInnerHTML={{
                    __html: item.field_bloque5,
                  }}
                />
              </center>
            </div>
          </>
        ))}
      </>
    </>
  );
  return (
    <>
      {" "}
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/services/servicio-consultorios-psicologia.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>
    </>
  );
}

export default ConsultoriosPsicologia;
